import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;


class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL2,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    createBusinessPartner(data) {
        return new Promise((success, error) => {
            http.post('/sellers', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
                // console.log(error.config);
            });
        });
    }

}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/BussinessPartners.js